import React, { useEffect, useState } from 'react'
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import PrintIcon from "@mui/icons-material/Print";
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { transparentStyle } from '../othersConstant'
import excelExport from '../../../../assets/extra/export-excel';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { excelConfig } from '../../../../assets/extra/excelConfig';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { jsPdfDidParseCellCallback, jsPdfWillDrawCellCallback } from '../../../generics/helper';
import { callAddFontRobotoBold } from '../../../../assets/fonts/Roboto-bold';
import { callAddFontRobotoNormal } from '../../../../assets/fonts/Roboto-normal';
import TablePaginationCustom from '../../../common/TablePagination';
import { getPOSPSCheck, updatePOSRefund } from '../../../../redux/KSRTC_Redux/others/OthersAction';

const RefundPOSTable = ({ reportData, setShowAlert, setSuccessModal, handleSubmit }) => {
    const store = useSelector((store) => store);
    const dispatch = useDispatch()
    const { user } = store
    const [tableData, setTableData] = useState([])
    const [searchData, setSearchData] = useState({
        BookingDate: '',
        ModificationTypeName: '',
        BookingRefNo: "",
        Amount: '',
        PassengerName: '',
        ContactNo: "",
        BusStation: '',
        Counter: "",
        LoginID: "",
        DeviceID: "",
    })
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(0)
    const refundColDefs = [
        { headerName: 'Sl No', field: 'Sno', headerSx: { textAlign: 'left', }, showFilter: false, xlCol: { dataType: 'string', dataFormatter: null, width: 25 } },
        { headerName: 'Transaction Date', field: 'EntryDateTime', headerSx: { textAlign: 'left', }, showFilter: true, xlCol: { dataType: 'string', dataFormatter: null, width: 25 } },
        { headerName: 'Modification Type', field: 'ModificationTypeName', headerSx: { textAlign: 'left', }, showFilter: true, xlCol: { dataType: 'string', dataFormatter: null, width: 25 } },
        { headerName: 'OB Ref No', field: 'OrderID', headerSx: { textAlign: 'left', }, showFilter: true, xlCol: { dataType: 'string', dataFormatter: null, width: 25 } },
        { headerName: 'Amount', field: 'Amount', headerSx: { textAlign: 'right', }, showFilter: true, xlCol: { dataType: 'number', dataFormatter: null, width: 25 } },
        { headerName: 'PNR No', field: 'BookingRefNo', headerSx: { textAlign: 'left', }, showFilter: true, xlCol: { dataType: 'string', dataFormatter: null, width: 25 } },
        { headerName: 'Passanger Name', field: 'PassengerName', headerSx: { textAlign: 'left', }, showFilter: true, xlCol: { dataType: 'string', dataFormatter: null, width: 25 } },
        { headerName: 'Mobile No', field: 'ContactNo', headerSx: { textAlign: 'left', }, showFilter: true, xlCol: { dataType: 'string', dataFormatter: null, width: 25 } },
        { headerName: 'Bus Station', field: 'BusStation', headerSx: { textAlign: 'left', }, showFilter: true, xlCol: { dataType: 'string', dataFormatter: null, width: 25 } },
        { headerName: 'Counter', field: 'Counter', headerSx: { textAlign: 'left', }, showFilter: true, xlCol: { dataType: 'string', dataFormatter: null, width: 25 } },
        { headerName: 'User', field: 'LoginID', headerSx: { textAlign: 'left', }, showFilter: true, xlCol: { dataType: 'string', dataFormatter: null, width: 25 } },
        { headerName: 'Device ID', field: 'DeviceID', headerSx: { textAlign: 'left', maxWidth: '50px' }, showFilter: true, xlCol: { dataType: 'string', dataFormatter: null, width: 25 } },
        { headerName: 'Action', field: 'action', headerSx: { textAlign: 'left', minWidth: '100px' }, showFilter: false, xlCol: { dataType: 'string', dataFormatter: null, width: 50 } },
    ]
    useEffect(() => {
        if (reportData?.length > 0) {
            setTableData(reportData)
        } else {
            setTableData([])
        }
    }, [reportData])
    useEffect(() => {
        let filterData = reportData.filter((val) =>
            (searchData?.BookingDate === "" || (val?.BookingDate && val?.BookingDate?.toLocaleLowerCase().includes(searchData?.BookingDate?.toLocaleLowerCase()))) &&
            (searchData?.ModificationTypeName === "" || (val?.ModificationTypeName && val?.ModificationTypeName?.toLocaleLowerCase().includes(searchData?.ModificationTypeName?.toLocaleLowerCase()))) &&
            (searchData?.BookingRefNo === "" || (val?.BookingRefNo && val?.BookingRefNo?.toLocaleLowerCase().includes(searchData?.BookingRefNo?.toLocaleLowerCase()))) &&
            (searchData?.Amount === "" || (val?.Amount && val?.Amount?.toString().includes(searchData?.Amount?.toString()))) &&
            (searchData?.PassengerName === "" || (val?.PassengerName && val?.PassengerName?.toLocaleLowerCase().includes(searchData?.PassengerName?.toLocaleLowerCase()))) &&
            (searchData?.ContactNo === "" || (val?.BookingRefNo && val?.ContactNo?.toLocaleLowerCase().includes(searchData?.ContactNo?.toLocaleLowerCase()))) &&
            (searchData?.BusStation === "" || (val?.BusStation && val?.BusStation?.toLocaleLowerCase().includes(searchData?.BusStation?.toLocaleLowerCase()))) &&
            (searchData?.Counter === "" || (val?.Counter && val?.Counter?.toLocaleLowerCase().includes(searchData?.Counter?.toLocaleLowerCase()))) &&
            (searchData?.LoginID === "" || (val?.LoginID && val?.LoginID?.toLocaleLowerCase().includes(searchData?.LoginID?.toLocaleLowerCase()))) &&
            (searchData?.DeviceID === "" || (val?.DeviceID && val?.DeviceID?.toLocaleLowerCase().includes(searchData?.DeviceID?.toLocaleLowerCase())))
        );
        setTableData(filterData);
    }, [searchData, reportData]);
    const generateExcel = async () => {
        try {
            const excelColumns = refundColDefs?.filter((obj) => obj.field !== 'action')?.map(col => ({
                colHeader: col.headerName,
                field: col.field,
                xlCol: col.xlCol
            }));

            const excelTableData = reportData.map(item => {
                return {
                    ...item,
                    isDataRow: true,
                };
            });
            const xlConfig = {
                ...excelConfig,
                columns: excelColumns,
                fileName: `POSFailureGPCStatus.xlsx`,
                showFilterSection: false,
                showSummarySection: false,
                showEmptyRow: true,
                headerRowStyle: { fill: '', bold: true },
                borderStyle: {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                },
                showHeader: true,
                workSheetTitle: `POS Failure GPC`,
                headerFooter: {
                    firstHeader: "POS Failure GPC",
                    firstFooter: "POS Failure GPC"
                },
                sheetHeaderData: [
                    {
                        "caption": "KARNATAKA STATE ROAD TRANSPORT CORPORATION",
                        "colSpan": excelColumns?.length,
                        "horizontal": "center",
                        "newRow": true
                    },
                    {
                        "caption": " POS Failure GPC",
                        "colSpan": excelColumns?.length,
                        "size": 12,
                        "horizontal": "center",
                        "newRow": true
                    },
                    {
                        "caption": `${user?.UserName || ''}(${sessionStorage.getItem('LoginId') || ""})`,
                        "colSpan": excelColumns?.length,
                        "horizontal": "right",
                        "size": 10,
                        "newRow": true
                    },
                ],
            };
            await excelExport.processExcel(xlConfig, excelTableData, []);
        } catch (err) {
            console.log(err);
        }
    }
    const generatePdf = (isSave) => {

        const pdfColumns = refundColDefs?.filter((obj) => obj.field !== 'action')?.map(col => ({
            header: col.headerName,
            dataKey: col.field,
            xlCol: col.xlCol
        }));

        const pdfTableData = reportData.map(item => {
            return {
                ...item,
                isDataRow: true,
            };
        });


        jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
        jsPDF.API.events.push(["addFonts", callAddFontRobotoNormal]);


        const doc = new jsPDF({
            orientation: 'l',
            format: 'a4',
            compress: true
        });
        var totalPagesExp = '{total_pages_count_string}';
        doc.autoTableSetDefaults({
            headStyles: { fontSize: 6, halign: 'left', fillColor: [30, 89, 167], },
        });
        const startY = 10;
        doc.setFontSize(14);
        doc.setTextColor("#000000");
        doc.setFont('Roboto', 'bold');
        doc.text(`KARNATAKA STATE ROAD TRANSPORT CORPORATION`, 85, startY);
        doc.setFont('Roboto', 'normal');
        doc.setFontSize(10);
        doc.setTextColor("#000000");
        doc.text(`POS Failure GPC`, 120, startY + 8);
        doc.text(`${user?.UserName || ''}(${sessionStorage.getItem('LoginId') || ""})`, doc.internal.pageSize.width - 5, startY + 16, "right");

        autoTable(doc, {
            startY: startY + 24,
            margin: { top: 3, left: 5, right: 5, bottom: 3 },
            tableWidth: 'auto',
            columns: pdfColumns,
            body: pdfTableData,
            columnStyles:
            {
                0: { halign: 'left', fontSize: 8, },
                1: { halign: 'left', fontSize: 8, },
                2: { halign: 'left', fontSize: 8, },
                3: { halign: 'left', fontSize: 8, },
                4: { halign: 'right', fontSize: 8, },
                5: { halign: 'left', fontSize: 8, },
                6: { halign: 'left', fontSize: 8, },
                7: { halign: 'left', fontSize: 8, },
                8: { halign: 'left', fontSize: 8, },
                9: { halign: 'left', fontSize: 8, },
                10: { halign: 'left', fontSize: 8, },
                11: { halign: 'left', fontSize: 8, },
                12: { halign: 'left', fontSize: 8, },


            },
            theme: 'grid',
            headStyles: {
                fillColor: null,
                textColor: [0, 0, 0],
                lineWidth: 0.2,
                fontSize: 10
            },
            didParseCell: (data) => {
                jsPdfDidParseCellCallback(data, pdfColumns, []);
            },
            willDrawCell: (data) => {
                jsPdfWillDrawCellCallback(data, true);
            },
            didDrawPage: function (data) {
                data.settings.margin.top = 16;
            },
            pageBreak: "auto"
        });
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`POS Failure GPC ${new Date().getTime()}.pdf`)

        } else {
            setTimeout(() => {
                const newTab = window.open();
                newTab.document.write('<iframe width="100%" height="100%" src="' + doc.output('datauristring', 'POS Refund') + '"></iframe>');
            }, 20)
        }
    }


    const handleSearchData = (event, field) => {
        setSearchData({ ...searchData, [field]: event.target.value.toString() })
    }

    const handleRefund = (val) => {
        const body = {
            OrderID: val?.OrderID,
            CounterID: user?.UserID,
            Amount: val?.Amount,
            intLogID: user?.loginData?.intLogID,
            UserId: user?.UserID
        }
        dispatch(updatePOSRefund(body)).then((res) => {
            if (res?.data?.status) {
                handleSubmit()
                setSuccessModal({
                    open: true,
                    msg: <div>Refund for OB Ref No: <span style={{ color: '#FF7100', fontWeight: 'bolder' }}>{val?.OrderID}</span> is Initiated Successfully </div>,
                })
            } else {
                setShowAlert({
                    open: true,
                    msg: res?.data?.Message,
                });
            }
        })
    }

    const handleCheckStatus = (val) => {
        const body = {
            OrderID: val?.OrderID
        }
        dispatch(getPOSPSCheck(body)).then((res) => {
            if (res?.data?.status) {
                handleSubmit()
                if (['pass', 'success'].includes(res?.data?.Message)) {
                    setSuccessModal({
                        open: true,
                        msg: <div>OB Ref No: <span style={{ color: '#FF7100', fontWeight: 'bolder' }}>{val?.OrderID}</span> is Payment is successful but {val?.ModificationTypeName || ''} not completed.</div>,
                    })
                } else {
                    setShowAlert({
                        open: true,
                        msg: res?.data?.Message,
                    });
                }
            } else {
                setShowAlert({
                    open: true,
                    msg: res?.data?.Message,
                });
            }
        })
    }
    return (
        <Box sx={{ padding: '16px 16px' }}>
            <TableContainer className='scrollBlue' component={Paper} sx={{
                marginBottom: "5px"
            }} >
                <Table stickyHeader size="small" aria-label="a dense table"
                    sx={{
                        '& .MuiTableCell-root': {
                            padding: '2px 4px',
                            fontSize: '14px !important'
                        },
                    }}
                >
                    <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                        <TableRow>
                            <TableCell
                                colSpan={refundColDefs?.length}
                                sx={{ backgroundColor: "#CCE7FF", height: "36px" }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <Typography
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            color: "#202020",
                                        }}
                                    >
                                        POS Failure GPC Listing
                                    </Typography>
                                    <Box>
                                        <Button
                                            startIcon={
                                                <svg
                                                    width="13"
                                                    height="17"
                                                    viewBox="0 0 13 17"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M2.375 0.5C1.20293 0.5 0.25 1.39688 0.25 2.5V14.5C0.25 15.6031 1.20293 16.5 2.375 16.5H10.875C12.0471 16.5 13 15.6031 13 14.5V5.5H8.75C8.1623 5.5 7.6875 5.05312 7.6875 4.5V0.5H2.375ZM8.75 0.5V4.5H13L8.75 0.5ZM5.41973 8.31875L6.625 9.94063L7.83027 8.31875C8.08262 7.97813 8.58066 7.89687 8.93926 8.13438C9.29785 8.37188 9.3875 8.84063 9.13516 9.17813L7.59785 11.25L9.13848 13.3188C9.39082 13.6594 9.30449 14.125 8.94258 14.3625C8.58066 14.6 8.08594 14.5188 7.83359 14.1781L6.625 12.5562L5.41973 14.1781C5.16738 14.5188 4.66934 14.6 4.31074 14.3625C3.95215 14.125 3.8625 13.6562 4.11484 13.3188L5.65215 11.25L4.11152 9.18125C3.85918 8.84062 3.94551 8.375 4.30742 8.1375C4.66934 7.9 5.16406 7.98125 5.41641 8.32188L5.41973 8.31875Z"
                                                        fill="#004F9E"
                                                    />
                                                </svg>
                                            }
                                            variant="contained"
                                            color="primary"
                                            style={{ ...transparentStyle }}
                                            onClick={() => {
                                                generateExcel()
                                            }}
                                        >
                                            Export As Excel
                                        </Button>
                                        <Button
                                            startIcon={
                                                <svg
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 18 18"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M6.50033 9.41699H7.33366V7.75033H8.16699C8.4031 7.75033 8.60102 7.67046 8.76074 7.51074C8.92046 7.35102 9.00033 7.1531 9.00033 6.91699V6.08366C9.00033 5.84755 8.92046 5.64963 8.76074 5.48991C8.60102 5.33019 8.4031 5.25033 8.16699 5.25033H6.50033V9.41699ZM7.33366 6.91699V6.08366H8.16699V6.91699H7.33366ZM9.83366 9.41699H11.5003C11.7364 9.41699 11.9344 9.33713 12.0941 9.17741C12.2538 9.01769 12.3337 8.81977 12.3337 8.58366V6.08366C12.3337 5.84755 12.2538 5.64963 12.0941 5.48991C11.9344 5.33019 11.7364 5.25033 11.5003 5.25033H9.83366V9.41699ZM10.667 8.58366V6.08366H11.5003V8.58366H10.667ZM13.167 9.41699H14.0003V7.75033H14.8337V6.91699H14.0003V6.08366H14.8337V5.25033H13.167V9.41699ZM5.66699 14.0003C5.20866 14.0003 4.8163 13.8371 4.48991 13.5107C4.16352 13.1844 4.00033 12.792 4.00033 12.3337V2.33366C4.00033 1.87533 4.16352 1.48296 4.48991 1.15658C4.8163 0.830187 5.20866 0.666992 5.66699 0.666992H15.667C16.1253 0.666992 16.5177 0.830187 16.8441 1.15658C17.1705 1.48296 17.3337 1.87533 17.3337 2.33366V12.3337C17.3337 12.792 17.1705 13.1844 16.8441 13.5107C16.5177 13.8371 16.1253 14.0003 15.667 14.0003H5.66699ZM2.33366 17.3337C1.87533 17.3337 1.48296 17.1705 1.15658 16.8441C0.830187 16.5177 0.666992 16.1253 0.666992 15.667V4.00033H2.33366V15.667H14.0003V17.3337H2.33366Z"
                                                        fill="#004F9E"
                                                    />
                                                </svg>
                                            }
                                            variant="contained"
                                            color="primary"
                                            style={{ ...transparentStyle }}
                                            onClick={() => {
                                                generatePdf(true)
                                            }}
                                        >
                                            Export As PDF
                                        </Button>
                                        <Button
                                            startIcon={<PrintIcon />}
                                            variant="contained"
                                            color="primary"
                                            style={{ ...transparentStyle }}
                                            onClick={() => {
                                                generatePdf(false)
                                            }}
                                        >
                                            Print
                                        </Button>
                                    </Box>
                                </Box>
                            </TableCell>
                        </TableRow>
                        <TableRow >
                            {refundColDefs?.map((col, index) => (
                                <TableCell
                                    key={`THR-${index}`}
                                    sx={{
                                        ...col.headerSx,
                                        height: "36px",
                                        backgroundColor: '#E5F3FF',
                                        color: '#202020',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        whiteSpace: 'nowrap',
                                        lineHeight: 1.3,
                                    }}
                                >
                                    {col.headerName}
                                </TableCell>))}
                        </TableRow>
                        <TableRow>
                            {refundColDefs.map((col, index) => col.showFilter ?
                                <TableCell key={`FTH-${index}`} sx={{ height: '36px' }}>
                                    <div className="filter-input" style={{}}>
                                        <input
                                            id={`filter-${index}`}
                                            className="field"
                                            name="cancelSearchInput"
                                            style={{ width: '100%' }}
                                            placeholder="Contains"
                                            value={searchData[col.field]}
                                            onChange={(e) => handleSearchData(e, col.field)}

                                        />
                                        <FilterAltIcon sx={{ paddingRight: '0px !important', color: '#aaa !important' }} />
                                    </div>
                                </TableCell>
                                : <TableCell key={`empty-cell-${index}`}></TableCell>)}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData.length > 0 ? (
                            rowsPerPage > 0
                                ? tableData.slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                )
                                : tableData
                        ).map((val) => (
                            <TableRow>
                                {refundColDefs.slice(0, -1)?.map((col) => (
                                    <TableCell sx={{ ...col?.headerSx, ...(col?.field === 'DeviceID' && { overflowWrap: 'break-word' }) }}>{val?.[col?.field]}</TableCell>
                                ))}

                                <TableCell>
                                    {val?.PaymentStatus?.toString()?.trim() === '' ?
                                        <Button
                                            variant="contained"
                                            size="medium"
                                            className="btn-orange"
                                            sx={{ height: '32px' }}
                                            onClick={() => {
                                                handleCheckStatus(val)
                                            }}
                                        >
                                            Check
                                        </Button> :
                                        ""
                                    }
                                </TableCell>

                            </TableRow>
                        ))
                            :

                            <TableRow>
                                <TableCell colSpan={refundColDefs?.length}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            color: 'red',
                                            fontSize: '14px',
                                        }}
                                    >
                                        <span>No Results Found For The Selected Filters.</span>
                                    </div>
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePaginationCustom totRowCount={tableData.length} rowsPerPageOptions={[10, 20, 30, { label: 'All', value: -1 }]} rowsPerPage={rowsPerPage} page={page} handleChangePage={(event, newPage) => {
                setPage(newPage)
            }} handleChangeRowsPerPage={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
            }} />
        </Box >
    )
}

export default RefundPOSTable